




























import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import Connectors from "./partials/charging-stations/Connectors.vue";
import appService from "@/services/appService";
import centrifugeClientFactory from "@/services/centrifugeClientFactory";
import merge from "@common/modules/vuetifyx/utils/merge";
import configProvider from "@common/services/configProvider";
import copy from "copy-to-clipboard";

export default Vue.extend({
    components: { Connectors },
    data() {
        return {
            self: this,
            tableContainer: new DataContainer(),
            tableOptions: {
                attrs: {
                    "item-key": "_id",
                    "sort-by": "name",
                    "sort-desc": false,
                    "show-expand": true,
                },
                content: {
                    name: "Retailer Detail",
                    urlEnabled: true,
                    search: {
                        ext: {
                            hidden: false,
                        },
                    },
                    filters: {
                        filters: {
                            tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Organization",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call(
                                                    "tenants",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            chargingLocationId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Site",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call(
                                                    "chargingLocations",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            retailerId: userManager.checkRole([
                                "systemAdmin", "admin",
                                "cpoAdmin", "cpoMonitor",
                            ]) && {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Retailer",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call(
                                                    "retailers",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            chargerVendorId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Charger Vendor",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call(
                                                    "chargerVendors",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            serialNumber: {
                                attrs: {
                                    label: "Serial Number",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                            uniqueId: {
                                attrs: {
                                    label: "Charge Point ID",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                            "connectorSettingItems.qrCode": {
                                attrs: {
                                    label: "QR Code",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                        },
                    },
                    displayFields: {
                        uniqueId: {
                            text: "Charge Point ID",
                            sortable: true,
                            options: {
                                attrs: {
                                    class: "font-weight-bold",
                                },
                            },
                        },
                        chargingLocation: {
                            text: "Site",
                            options: {
                                subProp: "chargingLocation.name",
                                label: true,
                                sortBy: "chargingLocationId",
                            },
                        },
                        chargingLocationAddress: {
                            text: "Address",
                            options: {
                                subProp: "chargingLocation.address",
                                tooltip: {
                                    content: {
                                        text: "chargingLocation.address",
                                    },
                                },
                                attrs: {
                                    class: "address-retailer-detail two-line-text",
                                },
                            },
                        },
                        connectors: {
                            text: "Connectors",
                        },
                        chargerVendor: {
                            text: "Vendor",
                            options: {
                                subProp: "chargerVendor.name",
                                label: true,
                                sortBy: "chargerVendorId",
                            },
                        },
                        chargerVendorBrand: {
                            text: "Model",
                            options: {
                                subProp: "chargerVendor.brand",
                            },
                        },
                        retailer: {
                            text: "Retailer",
                            options: {
                                subProp: "retailer.name",
                                label: true,
                                sortBy: "retailerId",
                            },
                        },
                        isPrivate: {
                            text: "Type",
                            options: {
                                boolean: true,
                                label: (value: boolean) => {
                                    return value ? "Private" : "Public";
                                },
                                attrs(value) {
                                    return {
                                        color: value ? "red" : "green",
                                    };
                                },
                            },
                        },
                        createdTime: {
                            text: "Created Time",
                            sortable: true,
                            options: {
                                filter: "dateTime",
                            },
                        },
                        updatedTime: {
                            text: "Updated Time",
                            sortable: true,
                            options: {
                                filter: "dateTime",
                            },
                        },
                        tenant: userManager.checkRole(["systemAdmin", "admin"]) && {
                            text: "Organization",
                            options: {
                                subProp: "tenant.name",
                                label: true,
                                sortBy: "tenantId",
                            },
                        },
                        action: {
                            text: "Actions",
                        },
                    },
                    multiSelectActionButtons: {
                        export: userManager.checkRole([
                            "systemAdmin", "admin",
                            "cpoAdmin", "cpoMonitor",
                            "retailer",
                        ]) && {
                            content: {
                                text: "Export selected",
                                icon: "mdi-microsoft-excel",
                            },
                            on: {
                                xClick({ self }) {
                                    const dataTable = self.context();
                                    coreApiClient.download("chargingStations", `@/export`, {
                                        payload: JSON.stringify({
                                            filters: [
                                                {
                                                    key: "_id",
                                                    operator: "in",
                                                    value: dataTable.model.value.map((item) => item._id),
                                                },
                                            ],
                                            limit: -1,
                                            extraParams: {
                                                currentTimeZoneOffset:
                                                    new Date().getTimezoneOffset() * -1 * 60 * 1000,
                                            },
                                        }),
                                    });
                                },
                            },
                        },
                    },
                    topActionButtons: {
                        export: userManager.checkRole([
                            "systemAdmin", "admin",
                            "cpoAdmin", "cpoMonitor",
                            "retailer",
                        ]) && {
                            content: {
                                text: "Export all",
                                icon: "mdi-microsoft-excel",
                            },
                            on: {
                                xClick({ self }) {
                                    const dataTable = self.context();
                                    coreApiClient.download(
                                        "chargingStations",
                                        `@/export`,
                                        dataTable.getFindAllOptions()
                                    );
                                },
                            },
                        },
                        insert: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                            target: {
                                dialog: {
                                    attrs: {
                                        width: "600px",
                                    },
                                },
                            },
                            ext: {
                                condition() {
                                    return appService.activeTenantValid();
                                },
                            },
                        },
                    },
                    template: {
                        itemActionButtons: {
                            edit: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                                target: {
                                    dialog: {
                                        attrs: {
                                            width: "600px",
                                        },
                                        ext: {
                                            subTitleMaker: "uniqueId",
                                        },
                                    },
                                },
                            },
                            delete: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {},
                            more: {
                                content: {
                                    icon: "mdi-dots-vertical",
                                },
                                target: {
                                    tooltip: {
                                        content: {
                                            text: "More Actions",
                                        },
                                    },
                                    menu: {
                                        content: {
                                            items: {
                                                viewChargingSessions: userManager.checkRole([
                                                    "systemAdmin", "admin",
                                                    "cpoAdmin", "cpoMonitor",
                                                    "retailer",
                                                    "user",
                                                ]) && {
                                                    content: {
                                                        text: "View Charging Sessions",
                                                    },
                                                    on: {
                                                        xClick({ self }) {
                                                            const menu = self.context();
                                                            const { dataTable, item } = menu.context();
                                                            const { $router } = dataTable.context();
                                                            $router.push({
                                                                path: "/app/charging_sessions",
                                                                query: {
                                                                    chargingStationId: item._id,
                                                                },
                                                            });
                                                        },
                                                    },
                                                },
                                                resetCharger: userManager.checkRole([
                                                    "systemAdmin", "admin",
                                                    "cpoAdmin",
                                                    "retailer",
                                                ]) && {
                                                    content: {
                                                        text: "Reset Charger",
                                                    },
                                                    target: {
                                                        confirm: {
                                                            content: {
                                                                content: {
                                                                    html: "Are you sure to reset this charger?",
                                                                },
                                                            },
                                                            on: {
                                                                async xYes({ self }) {
                                                                    const yesBtn = self.yesBtnContainer.value;
                                                                    const menu = self.context();
                                                                    const { dataTable, item } = menu
                                                                        .context()
                                                                        .context();
                                                                    yesBtn.loading.value = true;
                                                                    const result = await dataTable.execute(
                                                                        async () => {
                                                                            return await coreApiClient.call(
                                                                                "chargingStations",
                                                                                "reset",
                                                                                {
                                                                                    id: item._id,
                                                                                }
                                                                            );
                                                                        },
                                                                        undefined,
                                                                        {
                                                                            disableLoading: true,
                                                                            willRefresh: true,
                                                                        }
                                                                    );
                                                                    yesBtn.loading.value = false;
                                                                    if (result) {
                                                                        self.hide();
                                                                    }
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                                editAuthorizedCards: userManager.checkRole([
                                                    "systemAdmin", "admin",
                                                    "cpoAdmin",
                                                    "retailer",
                                                ]) && {
                                                    content: {
                                                        text: "Edit Authorize Cards",
                                                    },
                                                    target: {
                                                        dialog: {
                                                            handlers: {
                                                                initialize() {
                                                                    this.options.content.buttons.save.states.enabled =
                                                                        new DataContainer(false);
                                                                },
                                                            },
                                                            content: {
                                                                toolbar: {
                                                                    title: "Edit Authorize Cards",
                                                                    subTitle(dialog) {
                                                                        const menu = dialog.context();
                                                                        const btn = menu.context();
                                                                        const { item } = btn.context();
                                                                        return item.uniqueId;
                                                                    },
                                                                },
                                                                content: {
                                                                    type: "XForm",
                                                                    makeAttrs(attrs, dialog) {
                                                                        const { item } = dialog
                                                                            .context()
                                                                            .context()
                                                                            .context();
                                                                        attrs.xModel =
                                                                            dialog.options.content.buttons.save.states.enabled;
                                                                        attrs.xContext = dialog;
                                                                        attrs.xData = new DataContainer({
                                                                            authorizedCardItems:
                                                                                (item.authorizedCards &&
                                                                                    item.authorizedCards.map((value) => ({
                                                                                        value,
                                                                                    }))) ||
                                                                                [],
                                                                        });
                                                                        attrs.xOptions = {
                                                                            content: {
                                                                                sections: {
                                                                                    default: {
                                                                                        fields: {
                                                                                            authorizedCardItems: {
                                                                                                type: "XArrayInput",
                                                                                                attrs: {
                                                                                                    label: "Authorize Cards",
                                                                                                    required: true,
                                                                                                    xOptions: {
                                                                                                        content: {
                                                                                                            itemProperties: {
                                                                                                                value: {
                                                                                                                    attrs: {
                                                                                                                        required: true,
                                                                                                                    },
                                                                                                                },
                                                                                                            },
                                                                                                            template: {
                                                                                                                formOptions: {
                                                                                                                    content: {
                                                                                                                        colLength: 12,
                                                                                                                    },
                                                                                                                },
                                                                                                            },
                                                                                                        },
                                                                                                    },
                                                                                                },
                                                                                            },
                                                                                        },
                                                                                    },
                                                                                },
                                                                            },
                                                                        };
                                                                        return attrs;
                                                                    },
                                                                    attrs: {},
                                                                },
                                                                buttons: {
                                                                    save: {
                                                                        content: {
                                                                            text: "Save",
                                                                        },
                                                                        states: {},
                                                                        on: {
                                                                            async xClick({ self }) {
                                                                                const dialog = self.context();
                                                                                const menu = dialog.context();
                                                                                const btn = menu.context();
                                                                                const { item, dataTable } =
                                                                                    btn.context();
                                                                                const form =
                                                                                    dialog.contentContainer.value;
                                                                                const data = form.getData();
                                                                                self.loading.value = true;
                                                                                const result = await dataTable.execute(
                                                                                    async () => {
                                                                                        return await coreApiClient.call(
                                                                                            "chargingStations",
                                                                                            "update",
                                                                                            {
                                                                                                id: item._id,
                                                                                            },
                                                                                            {
                                                                                                data: {
                                                                                                    authorizedCards:
                                                                                                        data.authorizedCardItems.map(
                                                                                                            (item) => item.value
                                                                                                        ),
                                                                                                },
                                                                                            }
                                                                                        );
                                                                                    },
                                                                                    undefined,
                                                                                    {
                                                                                        disableLoading: true,
                                                                                        willRefresh: true,
                                                                                    }
                                                                                );
                                                                                self.loading.value = false;
                                                                                if (result) {
                                                                                    dialog.hide();
                                                                                }
                                                                            },
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                    ext: {
                                                        condition(self) {
                                                            const { item } = self.context().context();
                                                            return item?.isPrivate;
                                                        },
                                                    },
                                                },
                                                editAuthorizedVids: configProvider.get(
                                                    "AUTOCHARGE_ENABLED"
                                                ) &&
                                                    userManager.checkRole([
                                                        "systemAdmin", "admin",
                                                        "cpoAdmin",
                                                        "retailer",
                                                    ]) && {
                                                    content: {
                                                        text: "Edit Authorize Vehicles",
                                                    },
                                                    target: {
                                                        dialog: {
                                                            handlers: {
                                                                initialize() {
                                                                    this.options.content.buttons.save.states.enabled =
                                                                        new DataContainer(false);
                                                                },
                                                            },
                                                            content: {
                                                                toolbar: {
                                                                    title: "Edit Authorize Vehicles",
                                                                    subTitle(dialog) {
                                                                        const menu = dialog.context();
                                                                        const btn = menu.context();
                                                                        const { item } = btn.context();
                                                                        return item.uniqueId;
                                                                    },
                                                                },
                                                                content: {
                                                                    type: "XForm",
                                                                    makeAttrs(attrs, dialog) {
                                                                        const { item } = dialog
                                                                            .context()
                                                                            .context()
                                                                            .context();
                                                                        attrs.xModel =
                                                                            dialog.options.content.buttons.save.states.enabled;
                                                                        attrs.xContext = dialog;
                                                                        attrs.xData = new DataContainer({
                                                                            authorizedVidItems:
                                                                                (item.authorizedVids &&
                                                                                    item.authorizedVids.map(
                                                                                        (value) => ({ value })
                                                                                    )) ||
                                                                                [],
                                                                        });
                                                                        attrs.xOptions = {
                                                                            content: {
                                                                                sections: {
                                                                                    default: {
                                                                                        fields: {
                                                                                            authorizedVidItems: {
                                                                                                type: "XArrayInput",
                                                                                                attrs: {
                                                                                                    label: "Authorize Vehicles",
                                                                                                    required: true,
                                                                                                    xOptions: {
                                                                                                        content: {
                                                                                                            itemProperties: {
                                                                                                                value: {
                                                                                                                    attrs: {
                                                                                                                        required: true,
                                                                                                                    },
                                                                                                                },
                                                                                                            },
                                                                                                            template: {
                                                                                                                formOptions: {
                                                                                                                    content: {
                                                                                                                        colLength: 12,
                                                                                                                    },
                                                                                                                },
                                                                                                            },
                                                                                                        },
                                                                                                    },
                                                                                                },
                                                                                            },
                                                                                        },
                                                                                    },
                                                                                },
                                                                            },
                                                                        };
                                                                        return attrs;
                                                                    },
                                                                    attrs: {},
                                                                },
                                                                buttons: {
                                                                    save: {
                                                                        content: {
                                                                            text: "Save",
                                                                        },
                                                                        states: {},
                                                                        on: {
                                                                            async xClick({ self }) {
                                                                                const dialog = self.context();
                                                                                const menu = dialog.context();
                                                                                const btn = menu.context();
                                                                                const { item, dataTable } =
                                                                                    btn.context();
                                                                                const form =
                                                                                    dialog.contentContainer.value;
                                                                                const data = form.getData();
                                                                                self.loading.value = true;
                                                                                const result =
                                                                                    await dataTable.execute(
                                                                                        async () => {
                                                                                            return await coreApiClient.call(
                                                                                                "chargingStations",
                                                                                                "update",
                                                                                                {
                                                                                                    id: item._id,
                                                                                                },
                                                                                                {
                                                                                                    data: {
                                                                                                        authorizedVids:
                                                                                                            data.authorizedVidItems.map(
                                                                                                                (item) => item.value
                                                                                                            ),
                                                                                                    },
                                                                                                }
                                                                                            );
                                                                                        },
                                                                                        undefined,
                                                                                        {
                                                                                            disableLoading: true,
                                                                                            willRefresh: true,
                                                                                        }
                                                                                    );
                                                                                self.loading.value = false;
                                                                                if (result) {
                                                                                    dialog.hide();
                                                                                }
                                                                            },
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                    ext: {
                                                        condition(self) {
                                                            const { item } = self.context().context();
                                                            return item?.isPrivate;
                                                        },
                                                    },
                                                },
                                                editAppPassword: userManager.checkRole([
                                                    "systemAdmin", "admin",
                                                    "cpoAdmin",
                                                ]) && {
                                                    content: {
                                                        text: "Edit App Charging",
                                                    },
                                                    target: {
                                                        dialog: {
                                                            handlers: {
                                                                initialize() {
                                                                    this.options.content.buttons.save.states.enabled =
                                                                        new DataContainer(false);
                                                                },
                                                            },
                                                            content: {
                                                                autofocus: false,
                                                                toolbar: {
                                                                    title: "Edit App Charging",
                                                                    subTitle(dialog) {
                                                                        const menu = dialog.context();
                                                                        const btn = menu.context();
                                                                        const { item } = btn.context();
                                                                        return item.uniqueId;
                                                                    },
                                                                },
                                                                content: {
                                                                    type: "XForm",
                                                                    makeAttrs(attrs, dialog) {
                                                                        const { item } = dialog
                                                                            .context()
                                                                            .context()
                                                                            .context();
                                                                        attrs.xModel =
                                                                            dialog.options.content.buttons.save.states.enabled;
                                                                        attrs.xContext = dialog;
                                                                        attrs.xData = new DataContainer({
                                                                            appChargingAllowed:
                                                                                item.appChargingAllowed,
                                                                            appChargingPassword:
                                                                                item.appChargingPassword,
                                                                        });
                                                                        attrs.xOptions = {
                                                                            content: {
                                                                                sections: {
                                                                                    default: {
                                                                                        fields: {
                                                                                            appChargingAllowed: {
                                                                                                type: "boolean",
                                                                                                attrs: {
                                                                                                    label: "Allow App Charging",
                                                                                                },
                                                                                            },
                                                                                            appChargingPassword: {
                                                                                                type: "XPasswordInput",
                                                                                                attrs: {
                                                                                                    label: "Password",
                                                                                                },
                                                                                            },
                                                                                        },
                                                                                    },
                                                                                },
                                                                            },
                                                                        };
                                                                        return attrs;
                                                                    },
                                                                    attrs: {},
                                                                },
                                                                buttons: {
                                                                    save: {
                                                                        content: {
                                                                            text: "Save",
                                                                        },
                                                                        states: {},
                                                                        on: {
                                                                            async xClick({ self }) {
                                                                                const dialog = self.context();
                                                                                const menu = dialog.context();
                                                                                const btn = menu.context();
                                                                                const { item, dataTable } =
                                                                                    btn.context();
                                                                                const form =
                                                                                    dialog.contentContainer.value;
                                                                                const data = form.getData();
                                                                                self.loading.value = true;
                                                                                const result = await dataTable.execute(
                                                                                    async () => {
                                                                                        return await coreApiClient.call(
                                                                                            "chargingStations",
                                                                                            "update",
                                                                                            {
                                                                                                id: item._id,
                                                                                            },
                                                                                            {
                                                                                                data,
                                                                                            }
                                                                                        );
                                                                                    },
                                                                                    undefined,
                                                                                    {
                                                                                        disableLoading: true,
                                                                                        willRefresh: true,
                                                                                    }
                                                                                );
                                                                                self.loading.value = false;
                                                                                if (result) {
                                                                                    dialog.hide();
                                                                                }
                                                                            },
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    },
                                                    ext: {
                                                        condition(self) {
                                                            const { item } = self.context().context();
                                                            return item?.isPrivate;
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                            copyOcppUrl: userManager.checkRole([
                                "systemAdmin", "admin",
                                "cpoAdmin", "cpoMonitor",
                            ]) && {
                                content: {
                                    icon: "mdi-clipboard-multiple",
                                },
                                on: {
                                    xClick({ self }) {
                                        const { item, dataTable } = self.context();
                                        const url = `${configProvider.get("OCPP_BASE_URL")}/${item.tenantId
                                            }/${item._id}`;
                                        copy(url);
                                        dataTable.info.value = `OCPP URL has been copied to clipboard`;
                                    },
                                },
                                target: {
                                    tooltip: {
                                        content: {
                                            text: "Copy OCPP URL",
                                        },
                                    },
                                },
                            },
                        },
                    },
                    findAllOptionsFilter(options) {
                        const activeTenant = appService.getActiveTenant();
                        if (activeTenant) {
                            options.filters.push({
                                key: "tenantId",
                                operator: "equal_to",
                                value: activeTenant._id,
                            });
                        }
                        options.extraParams.currentTimeZoneOffset =
                            new Date().getTimezoneOffset() * -1 * 60 * 1000;
                        return options;
                    },
                },
                ext: {
                    dataProvider: {
                        async findAll(options) {
                            const { items, count } = await coreApiClient.call(
                                "chargingStations",
                                "findAll",
                                options
                            );
                            return [items, count];
                        },
                        async insert(item) {
                            return await coreApiClient.call(
                                "chargingStations",
                                "create",
                                undefined,
                                item
                            );
                        },
                        async update(item) {
                            return await coreApiClient.call(
                                "chargingStations",
                                "update",
                                {
                                    id: item._id,
                                },
                                {
                                    data: item,
                                }
                            );
                        },
                        async delete(item) {
                            return await coreApiClient.call("chargingStations", "delete", {
                                id: item._id,
                            });
                        },
                    },
                    default: {
                        defaultInputs: {
                            chargingLocationId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Site",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const filters = [
                                                    {
                                                        key: "_id",
                                                        operator: "equal_to",
                                                        value,
                                                    },
                                                ];
                                                const { items } = await coreApiClient.call(
                                                    "chargingLocations",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters,
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                            },
                            retailerId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Retailer",
                                    "item-value": "_id",
                                    "item-text": "name",
                                    "default": this.$route.params.id,
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const filters = [
                                                    {
                                                        key: "_id",
                                                        operator: "equal_to",
                                                        value,
                                                    },
                                                ];
                                                const { items } = await coreApiClient.call(
                                                    "retailers",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters,
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                            },
                            chargerVendorId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Charger Vendor",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const filters = [
                                                    {
                                                        key: "_id",
                                                        operator: "equal_to",
                                                        value,
                                                    },
                                                ];
                                                const { items } = await coreApiClient.call(
                                                    "chargerVendors",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters,
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                            },
                            serialNumber: {
                                attrs: {
                                    label: "Serial Number",
                                    required: true,
                                },
                            },
                            uniqueId: {
                                attrs: {
                                    label: "Charge Point ID",
                                    required: true,
                                },
                            },
                            isPrivate: {
                                type: "boolean",
                                attrs: {
                                    label: "Private",
                                },
                            },
                            connectorSettingItems: {
                                type: "XArrayInput",
                                attrs: {
                                    label: "Connector Settings",
                                    required: true,
                                    xOptions: {
                                        content: {
                                            itemLabel: (_, index) => {
                                                return `Connector ${+index + 1}`;
                                            },
                                            itemProperties: {
                                                connectorId: {
                                                    attrs: {
                                                        label: "Connector ID",
                                                        required: true,
                                                        disabled: true,
                                                    },
                                                },
                                                qrCode: {
                                                    attrs: {
                                                        label: "QR Code",
                                                        required: true,
                                                    },
                                                },
                                            },
                                            template: {
                                                formOptions: {
                                                    content: {
                                                        colLength: 12,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                                ext: {
                                    condition(self) {
                                        const { item } = self.context().context().context();
                                        return item?.isPrivate;
                                    },
                                },
                            },
                        },
                        insertForm: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                            content: {
                                fieldNames: [
                                    "uniqueId",
                                    "serialNumber",
                                    "chargingLocationId",
                                    "retailerId",
                                    "chargerVendorId",
                                    "isPrivate",
                                    "connectorSettingItems",
                                ],
                            },
                        },
                        editForm: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                            content: {
                                fieldNames: [
                                    "serialNumber",
                                    "chargingLocationId",
                                    "retailerId",
                                    "chargerVendorId",
                                    "isPrivate",
                                    "connectorSettingItems",
                                ],
                            },
                        },
                        delete: {
                            confirmDisplayField: "uniqueId",
                        },
                    },
                },
            },
        };
    },
    methods: {
        updateName(newName) {
            this.tableOptions.content.name = newName;
        },
        updateChargingStation(item) {
            const dataTable = this.tableContainer.value;
            const index = dataTable.items.value.findIndex(
                (it) => it.uniqueId === item.uniqueId
            );
            if (index >= 0) {
                const previousItem = dataTable.items.value[index];
                this.$set(
                    dataTable.items.value,
                    index,
                    merge.clone(previousItem, item)
                );
            }
        }
    },
    created() {
        const activeTenant = appService.getActiveTenant();
        const self = this;
        let channelName = "";

        if (activeTenant) {
            channelName = `private-chargingStations-tenantId=${activeTenant._id}`;
        } else if (userManager.checkRole(["cpoAdmin", "cpoMonitor"], true)) {
            channelName = `private-chargingStations-tenantId=${userManager.getUserInfo().tenant._id
                }`;
        } else if (userManager.checkRole(["retailer"], true)) {
            channelName = `private-chargingStations-tenantId=${userManager.getUserInfo().tenant._id
                }-retailerAdminUserId=${userManager.getUserInfo()._id}`;
        } else if (userManager.checkRole(["user"], true)) {
            channelName = `private-chargingStations-tenantId=${userManager.getUserInfo().tenant._id
                }-connectorItemsActiveUserId=${userManager.getUserInfo()._id}`;
        } else {
            channelName = `private-chargingStations`;
        }
        const socketId = userManager.getUserInfo()._id;

        const centrifuge = centrifugeClientFactory(null, async () => {
            const {
                auth
            } = await coreApiClient.call("chargingStations", "subscribe", {
                socketId,
                channelName,
                id: self.item._id,
                connectorId: 0
            });
            return auth;
        });
        this.centrifuge = centrifuge;

        if (channelName) {
            const sub = centrifuge.newSubscription(channelName);
            sub.on("publication", (ctx) => {
                const data = (ctx.data);
                self.updateChargingStation(data);
            });
            sub.subscribe();
            centrifuge.connect();
        }
    },
    destroyed() {
        if (this.centrifuge) {
            this.centrifuge.disconnect();
        }
    },
});
